export default __webpack_public_path__ + "static/email_black-09af5de8d6a26db16728e2ae9f269d3f.png";